import { render, staticRenderFns } from "./MintView.vue?vue&type=template&id=5ffbd544"
import script from "./MintView.vue?vue&type=script&lang=js"
export * from "./MintView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports